import * as __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3968a67e__ from "../../variants/tv.js";
const arrowSVGVariants = (0, __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3968a67e__.tv)({
    slots: {
        root: 'fill-none w-[20px] h-[10px]',
        path1: 'fill-[canvas]',
        path2: 'fill-gray-200 dark:fill-none',
        path3: 'dark:fill-gray-300'
    }
});
export { arrowSVGVariants };
